module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"background_color":"#252525","display":"browser","icon":"src/assets/favicon.png","name":"Яна Царик","short_name":"Яна Царик","start_url":"/","theme_color":"#252525","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"d0f3cffc61c7ee8aca734c37cd200380"},
    }]
